/* @flow */
import React from 'react';
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import CurrentUser from 'auth/CurrentUser';
import SignInForm from 'auth/components/SignInForm.jsx';
import { withDocumentTitle } from 'lib/documentTitle';

type Redirector = {
  onSignInRedirectTo?: any,
  attemptedTransition?: any,
  reset: () => void,
};

// TODO: Not sure why we have two of those.
// they are consumed the same way (router.push).
export const redirector: Redirector = {
  onSignInRedirectTo: null,
  attemptedTransition: null,
  reset() {
    this.onSignInRedirectTo = null;
    this.attemptedTransition = null;
  },
};

type Props = {
  location: Object,
};

class SignInPage extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  componentDidMount() {
    CurrentUser.addSignInListener(this.onSignIn);
    CurrentUser.addSignInNoRoleListener(this.onUserNoRoleSignin);
  }

  componentWillUnmount() {
    CurrentUser.removeSignInListener(this.onSignIn);
    CurrentUser.removeSignInNoRoleListener(this.onUserNoRoleSignin);
  }

  onSignIn = () => {
    const { query } = this.props.location;
    const { attemptedTransition, onSignInRedirectTo } = redirector;

    if (attemptedTransition) {
      redirector.reset();
      this.context.router.push(attemptedTransition);
      return;
    }

    if (onSignInRedirectTo) {
      redirector.reset();
      this.context.router.push(onSignInRedirectTo);
      return;
    }

    if (query.locationOnAuth) {
      const { locationOnAuth, ...rest } = query;
      this.context.router.push({
        pathname: locationOnAuth,
        query: rest,
      });
    } else if (query.join) {
      this.context.router.push(`/join/${query.join}`);
    } else {
      this.context.router.push('/');
    }
  }

  onUserNoRoleSignin = () => {
    this.context.router.push('/join/role_picker');
  }

  render() {
    const { query } = this.props.location;

    return (
      <AuthenticationView {...this.props} title="Log in">
        <SignInForm initialUid={query.email || query.uid || ''} />
      </AuthenticationView>
    );
  }
}

export { SignInPage };
export default withDocumentTitle('Sign in', SignInPage);



// WEBPACK FOOTER //
// ./src/auth/components/SignInPage.jsx